/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemStatus } from '../../models/system-status';

export interface Status$Params {
}

export function Status(http: HttpClient, rootUrl: string, params?: Status$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemStatus>> {
  const rb = new RequestBuilder(rootUrl, Status.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SystemStatus>;
    })
  );
}

Status.PATH = '/api/HealthCheck/Status';
